class Enum {
  constructor(map) {
    this.map = map;
  }

  getOptions() {
    let options = [];
    for (let key in this.map) {
      options.push({
        key: key,
        value: this.map[key]
      });
    }
    return options;
  }

  getValue(key) {
    return this.map[key];
  }

  setItems(items) {
    // 只覆盖已有属性
    for (const key in this.map) {
      if (key in items) {
        this.map[key] = items[key];
      }
    }
  }
}

const CouseType = new Enum({
  1: "一对一",
  2: "大班课",
  3: "小班课",
  4: "公开课",
  5: "点播课",
  7: "面授课",
  8: "音频课",
  9: "系统课",
  10: "图文课",
  15: "小组课",
  16: "线上双师课"
});

const PayStatus = new Enum({
  1: "待支付",
  2: "已支付",
  3: "退款申请中",
  4: "退款中",
  5: "已退款",
  6: "退款失败",
  11: "订单取消"
});

const ShopStatus = new Enum({
  1: "待支付",
  2: "已支付",
  3: "退款申请中",
  4: "退款中",
  5: "已退款",
  6: "退款失败",
  7: "退款拒绝",
  8: "待发货",
  9: "已发货",
  10: "确认发货",
  11: "订单取消"
});

const OrderStatus = new Enum({
  1: "待支付",
  2: "交易完成",
  3: "交易关闭"
});

const ShopType = new Enum({
  1: "一对一",
  2: "大班课",
  3: "小班课",
  4: "公开课",
  5: "点播课",
  7: "面授课",
  8: "音频课",
  9: "系统课",
  10: "充值余额",
  11: "图书",
  12: "文库",
  13: "会员",
  15: "小组课",
  16: "线上双师课"
});

const PayType = new Enum({
  1: "微信",
  2: "支付宝",
  3: "虚拟币支付",
  4: "苹果支付",
  5: "学习卡兑换",
  6: "赠送",
  7: "优惠券支付",
  8: "线下支付",
  9: "积分兑换",
  10: "免费"
});

const LiveStatus = new Enum({
  1: "未开始",
  2: "直播中",
  3: "已结束"
});

const ExamTopicType = new Enum({
  1: "单选题",
  2: "判断题",
  3: "多选题",
  4: "不定项选择题",
  5: "简答题",
  6: "材料题"
});

// 考试类型
const ExamType = new Enum({
  1: "模拟考试",
  2: "正式考试"
});

// 作业状态
const HomeworkStatus = new Enum({
  1: "未提交",
  2: "待批改",
  3: "已批改",
  4: "已过期",
  5: "已撤回"
});

// 作业报告状态
const HomeworkReportStatus = new Enum({
  1: "已批改",
  2: "未提交"
});

// 作业发布状态
const HomeworkPublishStatus = new Enum({
  1: "未发布",
  2: "已发布"
});

// 作业类型
const HomeworkType = new Enum({
  1: "课程作业",
  2: "课时作业"
});

// 难易度
const DifficultLevel = new Enum({
  1: "较难",
  2: "难",
  3: "中",
  4: "易",
  5: "较易"
});

// 试题类型
const QuestionType = new Enum({
  1: "单选题",
  2: "判断题",
  3: "多选题",
  4: "不定项选择题",
  5: "简答题",
  6: "材料题"
});

const QuestionTypeOther = new Enum({
  1: "单选",
  2: "判断",
  3: "多选",
  4: "不定项",
  5: "简答",
  6: "材料"
});

// 发货状态
const ShipStatus = new Enum({
  1: "待发货",
  2: "无需发货",
  3: "已发货",
  4: "已收货"
});

// 班级类型
const ClassType = new Enum({
  1: "手动成班",
  2: "自动成班"
});

// 学习状态
const StudyStatus = new Enum({
  1: "正常",
  2: "已过期"
});

export {
  CouseType,
  PayStatus,
  ShopStatus,
  OrderStatus,
  ShopType,
  PayType,
  LiveStatus,
  ExamTopicType,
  ExamType,
  HomeworkStatus,
  HomeworkReportStatus,
  HomeworkPublishStatus,
  HomeworkType,
  QuestionType,
  QuestionTypeOther,
  ShipStatus,
  ClassType,
  DifficultLevel,
  StudyStatus
};
